import React from 'react'
import DocumentationSidebar from './component/DocumentationSidebar'




export default function Analytics() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>

                            <h1 className='mt-0 text-primary'>Coming soon</h1>
                           

                            
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
